var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-overlay',{attrs:{"value":_vm.loading,"absolute":""}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"64","color":"primary"}})],1),(!_vm.loading)?_c('div',[_c('app-form',{attrs:{"parentObject":{
        data: this.formData,
        searchnew: this.search,
        pageTitle: this.pageTitle,
        pageTitleValue: this.pageTitleValue,
        errMsg: this.errMsg,
        isEdit: this.editMode,
      }},on:{"input":function($event){_vm.formData = $event},"new":_vm.createHandler,"save":_vm.saveHandler,"cancel":_vm.cancelHandler,"delete":function($event){_vm.isConfirm = !_vm.isConfirm}}}),(_vm.isErr)?_c('div',[_c('app-error',{attrs:{"parentError":{
          data: this.errMsg,
          isErr: this.isErr,
        }},on:{"closeError":function($event){_vm.isErr = $event}}})],1):_vm._e(),(_vm.isConfirm)?_c('div',[_c('app-confirm',{attrs:{"parentObject":{
          pageTitleValue: this.pageTitleValue,
          isConfirm: this.isConfirm,
        }},on:{"confirm":function($event){return _vm.deleteHandler($event)},"cancelConfirm":function($event){_vm.isConfirm = !_vm.isConfirm}}})],1):_vm._e()],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }